@use "@fukuri-admins/ui/layout" as *;

.Root {
  @media screen and (max-width: $TB) {
    padding: 0 24px
  }

  &__Header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  &__Title {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 28px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
    text-align: center;
    margin-bottom: 24px;
  }
  &__Actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 32px;
    margin-top: 7px;
  }
  .loading {
    display: flex;
    justify-content: center;
  }
}

.menuContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 32px;
  .outputCsv {
    cursor: pointer;
    padding: 8px 16px;
    border-radius: 6px;
    background-color: $Button;
    color: $White;
    svg {
      color: currentColor;
    }
    display: flex;
    align-items: center;
    font-weight: bold;
    gap: 4px;
    font-size: 16px;
    transition: background-color 0.2s ease-out;
    &:hover {
      background-color: $ButtonHover;
    }
  }
}
